import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextFieldComponent } from './text-field/text-field.component';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule } from '../buttons/buttons.module';
import { SelectPopoverButtonComponent } from './select-popover-button/select-popover-button.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DirectiveModule } from '@app/shared/directives/directive.module';
import { DateRangeFieldComponent } from './date-range-field/date-range-field.component';
import { InputTextFieldComponent } from './input-text-field/input-text-field.component';
import { CmSearchBoxModule } from '../cm-search-box/cm-search-box.module';
import { CmSearchBoxComponent } from '../cm-search-box/cm-search-box.component';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { DynamicFormControlComponent } from './dynamic-form-control/dynamic-form-control.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DropdownsModule } from '../dropdowns/dropdowns.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PopoverModule } from '../popover/popover.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule,
    ButtonsModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    DirectiveModule,
    CmSearchBoxModule,
    MatExpansionModule,
    MatSlideToggleModule,
    DropdownsModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
    PopoverModule,
  ],
  exports: [
    TextFieldComponent,
    InputTextFieldComponent,
    SelectPopoverButtonComponent,
    DateRangeFieldComponent,
    CmSearchBoxComponent,
    DynamicFormComponent,
  ],
  declarations: [
    TextFieldComponent,
    InputTextFieldComponent,
    SelectPopoverButtonComponent,
    DateRangeFieldComponent,
    DynamicFormComponent,
    DynamicFormControlComponent,
  ],
})
export class FormFieldsModule {}
